import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=4bb18f76&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=4bb18f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb18f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_dev\\workspace_front\\aikl_v2_front_kcc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb18f76')) {
      api.createRecord('4bb18f76', component.options)
    } else {
      api.reload('4bb18f76', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=4bb18f76&scoped=true&", function () {
      api.rerender('4bb18f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/Main.vue"
export default component.exports